import type { PurchaserConfigTemplate } from "@src/domain/entities/purchaser";
import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";

export class GetPurchaserConfigTemplateUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(purchaserId: number): Promise<PurchaserConfigTemplate | null> {
    return this.purchaserRepository.getPurchaserConfigTemplate(purchaserId);
  }
}
